import { render, staticRenderFns } from "./CommissionPreview.vue?vue&type=template&id=2828a6a7&scoped=true"
import script from "./CommissionPreview.vue?vue&type=script&lang=js"
export * from "./CommissionPreview.vue?vue&type=script&lang=js"
import style0 from "./CommissionPreview.vue?vue&type=style&index=0&id=2828a6a7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2828a6a7",
  null
  
)

export default component.exports